import { Form } from 'factorial-form'

class PersonalSituationForm extends Form {
  constructor(values: Record<string, unknown>) {
    super(values, {
      disability_percentage_cents: 'cents',
    })
  }
}

export default PersonalSituationForm
